module.exports = __webpack_public_path__ + "img/icon-easy.6bfa7e1c.svg";